import axiosInstance from 'common/js/axios-service'

export const getSelfAutoCharCodeTrialCount = () => {
  return axiosInstance.request({
    url: 'edu/get_self_auto_char_code_trial_count.json'
  })
}
